import { InitAdapter, SubmitAdapter } from '../../types';

export const initAdapter: InitAdapter = ({ deviation }) => {
  if (!(deviation && deviation.license)) {
    return {
      cc: false,
      attr: false,
      deriv: 'no',
    };
  }

  const { license } = deviation;
  return {
    cc: license.startsWith('by'),
    attr: ['by', 'by-sa', 'by-nd'].includes(license),
    deriv: {
      none: 'no',
      by: 'yes',
      'by-sa': 'share',
      'by-nd': 'no',
      'by-nc': 'yes',
      'by-nc-sa': 'share',
      'by-nc-nd': 'no',
    }[license],
  };
};

export const fieldToLicense = ({ cc, attr, deriv }) => {
  const licenseParts: string[] = [];

  if (!cc) {
    licenseParts.push('none');
  } else {
    licenseParts.push('by');
    if (!attr) {
      licenseParts.push('nc');
    }
    if (deriv === 'share') {
      licenseParts.push('sa');
    } else if (deriv === 'no') {
      licenseParts.push('nd');
    }
  }

  return licenseParts.join('-');
};

export const submitAdapter: SubmitAdapter = ({ license: { cc, attr, deriv } }) => ({
  license_options: {
    creative_commons: cc,
    commercial: attr,
    modify: deriv,
  },
});
